module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/router-wifi/routerWifi.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/router-wifi/routerWifi.png
// module id = 617
// module chunks = 0